import { render, staticRenderFns } from "./conteudo.vue?vue&type=template&id=0a316774&"
import script from "./conteudo.vue?vue&type=script&lang=js&"
export * from "./conteudo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports